import { render, staticRenderFns } from "./AfiliacionWizard.html?vue&type=template&id=3ab21d96&external"
import script from "./AfiliacionWizard.vue?vue&type=script&lang=js"
export * from "./AfiliacionWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports